module.exports = __webpack_public_path__ + "img/no-image-available.6cf9b98f.png";